import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProductModel } from "../../entities/product.model";
import { ProductInfoModel } from "../../entities/productinfo.model";

@Injectable()
export abstract class ProductRepositoryInterface {
    public abstract syncProducts(): Observable<ProductModel[]>;
    public abstract getProducts(search?: string): Observable<ProductModel[]>;
    public abstract getProductInfo(speCod: string, varCod: string, lang: string): Observable<ProductInfoModel>;
}
